module.exports = __webpack_public_path__ + "img/20180815_145911_037.66c896c1.jpg";